import { produce } from "immer";
import ACTIONS from "../actions/types.actions";

const downtimeReport = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.DOWNTIME_REPORT_REQUEST:
      draft[action.key] = true;
      return draft;
    case ACTIONS.DOWNTIME_REPORT_SUCCESS:
      draft.loading = false;
      draft.error = null;
      draft.list = action.response.list;
      draft.pagination = action.response.pagination;
      return draft;
    case ACTIONS.DOWNTIME_REPORT_ERROR:
      draft[action.key] = false;
      draft.error = action.error;
      return draft;
    default:
      return draft;
  }
});

export default downtimeReport;
